// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3JgMQ","form":"styles_form__2Qe8T"};